import React, { Component } from "react";
import News_BannerTitle from "../layouts/news/News_BannerTitle";
import NewsList_SideBar from "../layouts/news/NewsList_SideBar";
import News_Content from "../layouts/news/News_Content";
import { Header, Footer, TopBar, BottomBar } from "../layouts/general/index";

import data from "../../data/news.json";
import media from "../../data/mediaPartners.json";

class News extends Component {
  constructor(props) {
    super(props);
    const { location } = this.props;

    const params = new URLSearchParams(location.search);

    const ID = params.get("ID");
    const type = params.get("type");

    const allNews = data.news
      .sort((a, b) => {
        const aDate = new Date(a.releaseDate);
        const bDate = new Date(b.releaseDate);
        return bDate.getTime() - aDate.getTime();
      })
      .map((x) => {
        const date = new Date(x.releaseDate);
        return {
          ...x,
          id: x.ID,
          srcimg: x.headerImage,
          aritcles: "hentry data-effect",
          classnames:
            "post-media data-effect-item has-effect-icon offset-v-25 offset-h-24clerafix",
          date: date.toLocaleDateString("hr-HR"),
          day: date.getDate(),
          month: date.getMonth() + 1,
        };
      });

    const newsList = allNews.filter((y) => {
      if (type === "mediji") return y.categories.includes("Mediji");
      if (type === "blog") return y.categories.includes("Blog");
      return !y.categories.includes("Blog");
    });

    const news = newsList.find((x) => x.ID === ID);

    const newsIndex = newsList.findIndex((x) => x.ID === ID);

    let mediaPartners = media.mediaPartners.map((x) => {
      return { ...x };
    });

    this.state = {
      headers: [
        {
          id: 1,
          logoweb: "assets/img/logo-small.png",
          names: "Novosti",
        },
      ],
      banners: [
        {
          id: 1,
          links: "/news-list",
          titlelink: "Novosti",
          border: "|",
          name: "Novost",
          heading: "Novost",
        },
      ],
      newsList,
      news,
      newsIndex,
      allNews,
      mediaPartners,
    };
  }

  render() {
    const { newsList, news, newsIndex, allNews, mediaPartners } = this.state;

    return (
      <div className="header-fixed sidebar-right header-style-2 topbar-style-1 menu-has-search">
        <div id="wrapper" className="animsition">
          <div id="page" className="clearfix">
            <div id="site-header-wrap">
              <TopBar />
              {this.state.headers.map((data, idx) => (
                <Header data={data} key={idx} />
              ))}
            </div>
            {this.state.banners.map((data) => (
              <News_BannerTitle key={data.id} data={data} />
            ))}
            <div id="main-content" className="site-main clearfix">
              <div id="content-wrap" className="container">
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={60}
                  data-mobile={60}
                  data-smobile={60}
                />
                <News_Content
                  news={news}
                  next={newsIndex > 0 ? newsList[newsIndex - 1] : undefined}
                  prev={
                    newsIndex < newsList.length - 1
                      ? newsList[newsIndex + 1]
                      : undefined
                  }
                  url={window.location.href}
                />

                <NewsList_SideBar
                  mediaPartners={mediaPartners}
                  newsList={allNews
                    .filter((x) => !x.categories.includes("Blog"))
                    .slice(0, 3)}
                />
                <div
                  className="themesflat-spacer clearfix"
                  data-desktop={80}
                  data-mobile={60}
                  data-smobile={60}
                />
              </div>
            </div>
            <Footer />
            {this.state.headers.map((data, idx) => (
              <BottomBar data={data} key={idx} />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default News;
